import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/**
 * Breadcrumb — accessible trail. Pass items as [{ to, label }] with the current page
 * being the last entry (rendered as plain text, aria-current).
 */
export default function Breadcrumb({ items = [], className = '' }) {
  if (!items.length) return null;
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumb" className={`overline text-muted-foreground ${className}`}>
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-2">
              {isLast || !item.to ? (
                <span aria-current={isLast ? 'page' : undefined} className={isLast ? 'text-foreground' : ''}>
                  {item.label}
                </span>
              ) : (
                <Link to={item.to} className="link-underline">{item.label}</Link>
              )}
              {!isLast && <ChevronRight className="h-3 w-3 opacity-60" aria-hidden />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
